<plyr #plyr style="display: block;" class="w-100 h-100" [plyrDriver]="hlsjsDriver1" [plyrPlaysInline]="true" 
  (plyrInit)="player = $event" [plyrOptions]="plyrOptions" [plyrPoster]="poster" id="streamingPlayer"
  [plyrSources]="sources" *ngIf="sources[0].src"></plyr>
<div class="back-to-watch-list" [ngClass]="{'Back': !backButtonHidden, 'hidden': backButtonHidden}">
  <div class="back-position cursor-pointer" (click)="back()">
    <!-- <i class="fas fa-arrow-left fs-18" ></i><span class="pr-2 pl-2">Back</span> -->
  </div>
</div>